import {SpaceTr, Tr, TrSpace} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {PurchaseInfo} from "@/store/shop/types";
import {Link} from "@/scenes.ui/link";
import BonusPointUtils from "@/utils/bonus-point-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class StatusAcquiredPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, pi: PurchaseInfo, showManual: () => unknown) {
        super(scene, canvas, Tr('success.purch'));

        let blockFirst = TextUtils.addTextAdvanced(scene, TrSpace('cngrts.stat')
            + BonusPointUtils.getStatusGenetive(pi.statusAfterPurchase) + SpaceTr('b.sts'), 0, -160,
            '#fff609', 16, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        const pict = SpriteUtils.addImage(this.scene, 0, blockFirst.y / CU.S + 45, Keys.IC_100_MITHRIL).setOrigin(0.5, 0);
        const pict2 = SpriteUtils.addImage(this.scene, -110, blockFirst.y / CU.S + 45, Keys.IC_100_MITHRIL).setOrigin(0.5, 0);
        const pict3 = SpriteUtils.addImage(this.scene, 110, blockFirst.y / CU.S + 45, Keys.IC_100_MITHRIL).setOrigin(0.5, 0);

        let statusKey = BonusPointUtils.getImageKey(pi.statusAfterPurchase);
        scene.load.image(statusKey, `assets/ui/${statusKey}.png`);
        scene.load.once(Phaser.Loader.Events.COMPLETE, () => {
            SpriteUtils.setSprite(scene, pict ,statusKey);
            SpriteUtils.setSprite(scene, pict2, statusKey);
            SpriteUtils.setSprite(scene, pict3, statusKey);
        });
        scene.load.start();

        let blockSecond = TextUtils.addTextAdvanced(scene, TrSpace('st.desc.1')
            + BonusPointUtils.getStatusPercent(pi.statusAfterPurchase) + Tr('pct.gms'), 0, 30,
            '#cecece', 13, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        let manual = new Link(scene, 0, 75 * CU.S, Tr('det'), showManual,
            '#D0D0D0', 12, 0.5);

        this.add([blockFirst, blockSecond, manual, pict, pict2, pict3]);

        this.addCustomButton(0, 170, Tr('prinjat'), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {});
    }
}
